import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card,
  Page,
  Text,
  Radio,
  RadioGroup,
} from '../../components';
import { toggleRedesign } from '../../modules/redesign';
import { getIsRedesign } from '../../modules/selectors';

const propTypes = {
  isRedesign: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

class Redesign extends Component {
  handleChange = (value) => {
    const { dispatch } = this.props;
    dispatch(toggleRedesign(value));
  };

  render() {
    const { isRedesign } = this.props;
    return (
      <Page>
        <Card>
          <Card.Block>
            <Text as="h1">Redesign</Text>
            <RadioGroup name="toggleRedesign" defaultChecked={isRedesign ? 'on' : 'off'}>
              <Radio key="off" name="off" label="Off" value="off" onChange={() => this.handleChange(false)} />
              <Radio key="on" name="on" label="On" value="on" onChange={() => this.handleChange(true)} />
            </RadioGroup>
          </Card.Block>
        </Card>
      </Page>
    );
  }
}
function mapStateToProps(state) {
  return {
    isRedesign: getIsRedesign(state),
  };
}

Redesign.propTypes = propTypes;
export default connect(mapStateToProps)(Redesign);
